import axios from 'axios'
import { API_URL } from '../constants'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Admin } from '@/types/admins'

export type NewAdminParams = {
  username: string
  full_name: string
}

export async function inviteNewAdmin(params: NewAdminParams): Promise<Admin> {
  const url = `${API_URL}/admins/invite/`
  const { data } = await axios.post(url, params, { withCredentials: true })
  return data
}

export function useInviteAdmin() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: inviteNewAdmin,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['admins'],
      })
    },
  })
}
